import { PercentPipe } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthService } from '../../../auth/auth.service';
import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { firstLoadCheat } from '../../first-load-cheat';
import { ColumnConfigItem } from '../models/coaching.global.model';
import { ACTIVE_TAB_VIEW, OaPerson, Opportunity } from '../models/oa.model';
import { SortDirection } from '../models/sorting.model';
import { CoachingInsightWidgetService } from '../services/coaching-insight.widget.service';
import { TeamOAService } from '../services/team-oa.service';

// maintain a list of Team Member Metrics
@Component({
    selector: '[personList]',
    templateUrl: './person-list.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PercentPipe],
})
export class PersonListComponent implements OnInit {
    @Input() people: OaPerson[] | OaPerson;
    @Input() type: string;
    @Input() columns: ColumnConfigItem[];
    @Input() activeMetric: Opportunity;
    @Input() activeMember: OaPerson;
    @Input() activecolumns: number;
    @Input() rowExpanded: boolean;
    @Input() openNonKPI: boolean;
    @Input() triggeredSort: boolean;
    @Input() activeView: ACTIVE_TAB_VIEW;

    @Output() rowExpandedChange: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() openedWithNonKPIButton: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() openedWithoutOpp: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() metricsRendered: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() reorderedPeople: EventEmitter<SortDirection> =
        new EventEmitter<SortDirection>();

    @ViewChild('oatooltip') oatooltip: TemplateRef<any>;
    @ViewChild('nonkpitooltip') nonkpitooltip: TemplateRef<any>;

    @ViewChild('activeRowDetail') activeRowDetail: ElementRef;

    moreOAMetricsOpened: boolean = false;
    moreNonOAMetricsOpened: boolean = false;
    oametrictypeSelected: string = '';
    oafilterSortSelected: string;

    ascendingSort: boolean = false;

    filtersub: Subscription;

    startLoadingPerformers: boolean;

    destroyedComponent = false;

    i18n = TranslationKeyMap;

    displayPeople: OaPerson[] | OaPerson = null;

    noneToDisplay: boolean = false;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _coachingInsightService: CoachingInsightWidgetService,
        private readonly _teamOAService: TeamOAService,
        private readonly _authService: AuthService, // private readonly _cdRef: ChangeDetectorRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    get user() {
        return this._authService.user;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this.startLoadingPerformers = false;
        if (this.destroyedComponent) {
            // this._cdRef.reattach();
        }
        this.destroyedComponent = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnChanges(args) {
        // eslint-disable-next-line no-prototype-builtins
        if (args.hasOwnProperty('people')) {
            this.startLoadingPerformers = false;
            this.renderList();
        }
        // eslint-disable-next-line no-prototype-builtins
        if (args.hasOwnProperty('activecolumns')) {
            // this._cdRef.detectChanges();
        }
        // eslint-disable-next-line no-prototype-builtins
        if (args.hasOwnProperty('columns')) {
            // this._cdRef.detectChanges();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngAfterViewInit() {
        this.renderList();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    renderList() {
        if (this.startLoadingPerformers) return;

        let length = (this.people as OaPerson[]).length;

        this.displayPeople =
            length !== undefined
                ? (this.people as OaPerson[]).filter((d) => d.display === true)
                : (this.people as OaPerson);

        if (length > 1) {
            length = (this.displayPeople as OaPerson[]).length;
        }

        // const timer = length > 8 ? 800 : 0;

        if ((this.displayPeople as OaPerson[]).length) {
            const f = (this.displayPeople as OaPerson[]).filter(
                (g) => g.displayForTeam === true,
            );
            // eslint-disable-next-line no-unneeded-ternary, @typescript-eslint/prefer-optional-chain
            this.noneToDisplay = f && f.length ? false : true;
        }

        setTimeout(() => {
            this.startLoadingPerformers = true;

            firstLoadCheat(this._el.nativeElement);

            // eslint-disable-next-line @typescript-eslint/dot-notation
            // if (!this._cdRef['destroyed']) {
            //     this._cdRef.detectChanges();
            // }
        }, 100);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleScoreTooltip(tooltip: any, member: OaPerson) {
        member && !tooltip.isOpen()
            ? tooltip.open({ member })
            : tooltip.close();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    sortTeamByScore(direction?: SortDirection) {
        const newdir = this._teamOAService.sortTeamByScore(direction);
        this.reorderedPeople.emit(newdir);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    track_identify(index, item: OaPerson) {
        return item.userId;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    trackPeople(index, item: OaPerson) {
        return typeof item === 'undefined' ? item : item.display;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        this.destroyedComponent = true;
        // this._cdRef.detach();
    }
}
